import { InjectionToken } from "@angular/core";
import { Rbac } from "../../constants/rbac";
import { Role } from "../../models/role.enum";


export const ACTIONS_BY_ROLE = new InjectionToken<Record<Role, Rbac[]>>('ACTIONS_BY_ROLE');
